<script>
  export let checked = false

  export let onClick
</script>

<button on:click={onClick}>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" fill={checked ? "#00468F" : "white"} stroke="#CCCCCC"/>
    {#if checked}
      <path d="M5 11L10 16L19 7" stroke="white" stroke-width="3"/>
    {/if}
  </svg>
</button>
